module.exports = __webpack_public_path__ + "static/img/psw.13f5ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/psw.png
// module id = wsY1
// module chunks = 1